export default __webpack_public_path__ + "static/media/PERIODS.9bcd59df.png";